
import { Component, Vue } from 'vue-property-decorator'
import { getCompanyList, addCompany, putCompany, delCompany } from '@/api/admin'
import { IArticleData } from '@/api/types'
import { Form } from 'element-ui'

@Component({
  name: 'Company'
})
export default class extends Vue {
  private list: IArticleData[] = []
  private listLoading = true
  private dialogFormVisible = false
  private title = '新增仪表'
  private company = ''
  private total = 0
  private sub = ''
  private listQuery = {
    company: '',
    page: 1,
    pagesize: 10
  }
  private initForm = {
    company: '',
    abbreviation: '',
    companyNember: '',
    companyAddress: '',
    companyPhone: '',
    managementName: '',
    managementPhone: '',
    companyType: '',
    leader: '',
    leaderPhone: '',
    message: '',
    webAddress: ''
  }
  private form = { ...this.initForm }
  private rules = {
    company: [
      { required: true, message: '请输入名称', trigger: 'blur' }
    ],
    companyAddress: [
      { required: true, message: '请输入公司地址', trigger: 'blur' }
    ],
    companyType: [
      { required: true, message: '请输入企业类型', trigger: 'blur' }
    ],
    companyPhone: [
      { required: true, message: '请输入正确的电话号', trigger: 'blur' }
    ]
  }
  private formLabelWidth = '120px'

  created() {
    this.getList()
  }
  private async getList() {
    this.listLoading = true
    const { data } = await getCompanyList(this.listQuery)
    this.list = data.items
    this.total = data.total
    this.listLoading = false
  }
  // 新增 修改
  private async changeHandel(row:any) {
    this.dialogFormVisible = true
    if (row) {
      this.title = '修改仪表'
      this.sub = 'put'
      this.form = row
    } else {
      this.title = '新增仪表'
      this.sub = 'add'
      this.form = this.initForm
    }
  }
  // 新增修改 保存
  private async submitHandle() {
    (this.$refs.form as Form).validate(async(valid) => {
      if (valid) {
        if (this.sub === 'add') {
          const res = await addCompany(this.form)
          if (res) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
          }
        } else {
          const res = await delCompany(this.form)
          if (res) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
          }
        }
        this.dialogFormVisible = false
      }
    })
  }
  // 删除
  private async delHandel(id:any) {
    this.$confirm('确定要删除该企业？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const res = delCompany({ id })
      return
      if(res) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }
    }).catch(err => {
      console.log(err)
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
  // 分页切换
  private async handleCurrentChange(page:any) {
    this.listQuery. page = page
    this.getList()
  }
}
